import { LocaleLink } from "@/components/LocaleLink";
import logo from "@/assets/logo.png";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { useLanguage } from "@/contexts/LanguageContext";
import { Mail, MapPin, MessageSquare } from "lucide-react";

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-foreground text-background">
      {/* CTA Section */}
      <div className="container mx-auto px-4 py-16"></div>

      <div className="container mx-auto px-4 pb-12">
        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img src={logo} alt="Dealigator" className="h-8 w-8" />
              <span className="text-xl font-bold">Dealigator</span>
            </div>
            
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t.footer.platform.title}</h4>
            <ul className="space-y-2 text-sm text-background/60">
              <li>
                <LocaleLink to="/" className="hover:text-background transition-colors">
                  {t.nav.home}
                </LocaleLink>
              </li>
              <li>
                <LocaleLink to="/properties" className="hover:text-background transition-colors">
                  {t.nav.deals}
                </LocaleLink>
              </li>
              <li>
                <LocaleLink to="/pricing" className="hover:text-background transition-colors">
                  {t.nav.pricing}
                </LocaleLink>
              </li>
              <li>
                <LocaleLink to="/contact" className="hover:text-background transition-colors">
                  {t.footer.contact.title}
                </LocaleLink>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4">{t.footer.contact.title}</h4>
            <ul className="space-y-3 text-sm text-background/60">
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4" />
                {t.footer.contact.location}
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4" />
                contact@dealigator.com
              </li>
              <li>
                <LocaleLink to="/contact" className="flex items-center gap-2 hover:text-background transition-colors">
                  <MessageSquare className="h-4 w-4" />
                  {t.footer.contact.feedback}
                </LocaleLink>
              </li>
            </ul>
          </div>
        </div>

        <Separator className="bg-background/10 mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-background/40">
          <div>© 2026 Dealigator. {t.footer.legal.rights}</div>
          <div className="flex gap-6">
            <LocaleLink to="/privacy" className="hover:text-background transition-colors">
              {t.footer.legal.privacy}
            </LocaleLink>
            <LocaleLink to="/terms" className="hover:text-background transition-colors">
              {t.footer.legal.terms}
            </LocaleLink>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;
